var _defs, _g, _rect;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg3 = function Svg3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FFE183;\n      }\n      .cls-2 {\n        fill: #FCD541;\n      }\n      .cls-3 {\n        fill: #4F5B5E;\n      }\n      .cls-4 {\n        fill: none;\n      }\n      .cls-5 {\n        fill: #F0F2F2;\n      }\n      .cls-6 {\n        fill: #434849;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10.04,14h-4.07c-2.19,0-3.96-1.77-3.96-3.96v-4.07c0-2.19,1.78-3.96,3.96-3.96h4.07c2.19,0,3.96,1.77,3.96,3.96h0v4.07c0,2.19-1.77,3.96-3.96,3.96h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.63,5.49c.41,0,.73-.33.73-.73,0-.16-.05-.31-.15-.44-.52-.69-1.33-1.09-2.19-1.09h-4.07c-.86,0-1.66.4-2.18,1.09-.24.32-.18.78.14,1.03.13.1.28.15.44.15h7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m8,11.39c-.85,0-1.69-.16-2.47-.5-.23-.11-.34-.38-.23-.61.11-.23.38-.34.61-.23h0c.66.28,1.37.42,2.09.41.72,0,1.43-.13,2.09-.41.23-.11.51,0,.61.23.11.23,0,.51-.23.61-.78.34-1.62.51-2.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m14,5.56h0c0-.21-.19-.37-.39-.36,0,0,0,0,0,0l-3.28.16c-.53,0-1.05.15-1.5.44l-.21.14c-.07.04-.15.07-.23.07h-.76c-.08,0-.16-.02-.23-.07l-.21-.14c-.45-.29-.97-.44-1.5-.44l-3.28-.16c-.21,0-.38.16-.39.37,0,.2.15.37.35.39h.07l.16,1.21c.16,1.18,1.12,2.08,2.3,2.17,1.15.07,2.2-.67,2.53-1.78l.16-.55c.04-.15.18-.25.34-.25h.15c.16,0,.3.1.34.25l.15.51c.27.96,1.09,1.66,2.07,1.8,1.34.17,2.57-.77,2.76-2.11l.18-1.25h.07c.21-.01.37-.19.36-.4,0,0,0,0,0,0m-9.05,3.2c-.91-.06-1.65-.76-1.77-1.66l-.12-.84c-.02-.12.07-.23.19-.25.01,0,.03,0,.04,0l2.36.11h.02c.39,0,.77.11,1.1.32l.21.13h0c.06.04.1.12.07.19l-.18.63c-.25.84-1.04,1.4-1.92,1.36m7.86-1.62c-.15,1.04-1.11,1.76-2.15,1.61-.74-.12-1.34-.65-1.54-1.37l-.17-.6c-.02-.08,0-.16.07-.2h0l.21-.14c.33-.21.71-.32,1.1-.32l2.38-.11c.12,0,.22.09.23.21,0,.01,0,.03,0,.04l-.12.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.57,12.19h-.59c-.24,0-.43-.19-.43-.43v-.72c0-.16.13-.29.29-.29h1.15v1.01c0,.24-.19.43-.43.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.02,12.19h-.59c-.24,0-.43-.19-.43-.43v-1.02h1.15c.16,0,.29.13.29.29v.72c0,.24-.19.43-.43.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m6.43,7.27c0-.44-.36-.8-.8-.8s-.8.36-.8.8.36.8.8.8.8-.36.8-.8h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m11.16,7.27c0-.44-.36-.79-.8-.79-.44,0-.79.36-.79.8,0,.44.35.79.79.79.44,0,.8-.35.8-.79,0,0,0,0,0,0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 16,
    height: 16
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3.85310842.svg";
export { ForwardRef as ReactComponent };